<template>
  <div
      :data-card-title="title"
      class="personal-card-container"
      :class="{
        'not-editable':editSection !== '' && editSection !== title,
        'personal-card-container--double': isDoubleCard
      }"
  >
    <slot v-bind="this.$props"></slot>

  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    editSection: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    isDoubleCard: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped>
.personal-card-container
  outline 1px solid rgba(128,128,128,0.349)
  position relative
  padding 15px
  width 400px
  height fit-content
  @media (max-width 1142px)
    width 100%
  &:is(.not-editable)
    height 250px
    &:has(.card-team-management)
      height fit-content
.personal-card-container:is(.not-editable)
  &:before
    color #A5A5A5
    opacity .8
.personal-card-container:before
  color #293033
  display block
  position absolute
  top -13px
  left -3px
  width fit-content
  content attr(data-card-title)
  padding-right 5px
  background-color white
  font-size 16px
  @media screen and (min-width 1024px)
    font-size 18px
</style>
